package com.ilussobsa.views.dialogs

import com.ilussobsa.SavedSearch
import com.ilussobsa.Strings
import com.ilussobsa.sdk.currentSessionNullable
import com.ilussobsa.sdk.currentSession
import com.lightningkite.kiteui.models.Align
import com.lightningkite.kiteui.navigation.KiteUiScreen
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.await
import com.lightningkite.kiteui.reactive.awaitNotNull
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.report
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*


class RemoveSearch(val search: Readable<SavedSearch>): KiteUiScreen {

        override fun ViewWriter.render() {

            dismissBackground {
                centered - card - col {
                    h2(Strings.removeSearch)
                    text { ::content{ Strings.thisActionWillRemoveX(search().name) } }
                    gravity(Align.Center, Align.Center) - row {
                        danger - button {
                            h6(Strings.remove)
                            onClick {
                                try {
                                    currentSessionNullable.awaitNotNull().savedSearches.get(
                                        search.await()._id,
                                    ).delete()

                                    navigator.dismiss()
                                } catch (e: Exception) {
                                    e.report()
                                    alert(
                                        Strings.error,
                                        Strings.thereWasAnErrorRemovingTheSavedSearch
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }